import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import ColorPricingCategoryService from "../../../../services/ColorPricingCategoryService";
import ColorPricingCategoryForm from "./forms/ColorPricingCategoryForm";
import { useColorPricingCategoryContext } from "../../../../contexts/color-pricing-category.context";

function ColorPricingAddEdit() {
  debugger;
  const { id } = useParams();
  let history = useHistory();
  const { getAllColorPricingCategory } = useColorPricingCategoryContext();

  const [formData, setData] = useState({
    ID: 0,
    NoColorIncluded: "",
    NoLocIncluded: "",
    PricingType: "",
    active: false,
  });

  const getData = async () => {
    debugger;
    const result = await ColorPricingCategoryService.getOne(id);
    if (result) setData(result);
  };

  useEffect(() => {
    getData();
  }, []);

  const saveBuRunCharge = async (data) => {
    if (id) {
      // Edit Deco Method
      debugger;
      //   const postData = new FormData();
      //   postData.append("ID", data.burctC_ID);
      //   postData.append("BU", data.bu);
      //   postData.append("Col1", data.col1);
      //   postData.append("Col3", data.col3);
      //   postData.append("LTM", data.ltm);
      //   postData.append("Col5", data.col5);
      //   postData.append("RunChargeType", data.runChargeType);
      //   postData.append("Lookup", data.lookup);

      const postData = {
        ID: id,
        NoColorIncluded: data.noColorIncluded,
        NoLocIncluded: data.noLocIncluded,
        PricingType: data.pricingType,
      };

      const result = await ColorPricingCategoryService.update(postData);
      if (result.success === true) {
        getAllColorPricingCategory();
        history.goBack();
      }
    } else {
      debugger;
      const postData = {
        NoColorIncluded: data.noColorIncluded,
        NoLocIncluded: data.noLocIncluded,
        PricingType: data.pricingType,
      };
      const result = await ColorPricingCategoryService.add(postData);
      if (result.success === true) {
        getAllColorPricingCategory();
        history.goBack();
      }
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Color Pricing Category</h4>
      <hr />
      <ColorPricingCategoryForm formData={formData} submitForm={saveBuRunCharge} />
    </div>
  );
}

export default ColorPricingAddEdit;
